import { Route } from "@angular/router";

export const OrganizationPaths = {
  OrganizationEdit: "",
  LocalGovernment: "lokaal-bestuur",
  GeneralInfo: "algemene-gegevens",
  Filters: "filters",
  FederationInfo: "federatie",
};
export default [
  {
    path: OrganizationPaths.OrganizationEdit,
    loadComponent: () =>
      import("./pages/organization-edit/organization-edit.component").then(
        (c) => c.OrganizationEditComponent
      ),
    data: {
      breadcrumb: "Mijn organisatie",
      title: "Mijn organisatie",
    },
  },
  {
    path: OrganizationPaths.LocalGovernment,
    loadComponent: () =>
      import("./pages/organization-edit/organization-edit.component").then(
        (c) => c.OrganizationEditComponent
      ),
    data: {
      breadcrumb: "Mijn lokaal bestuur",
      title: "Mijn lokaal bestuur",
    },
  },
  {
    path: OrganizationPaths.GeneralInfo,
    loadComponent: () =>
      import("./pages/general-info/general-info.component").then((c) => c.GeneralInfoComponent),
    data: {
      breadcrumb: "Algemene gegevens",
      title: "Algemene gegevens van het lokaal bestuur",
    },
  },
  {
    path: "general-info",
    redirectTo: OrganizationPaths.GeneralInfo,
  },
  {
    path: OrganizationPaths.FederationInfo,
    loadComponent: () =>
      import("./pages/organization-federation-info/organization-federation-info.component").then(
        (c) => c.OrganizationFederationInfoComponent
      ),
    data: {
      breadcrumb: "Federatie",
      title: "Federatiegegevens",
    },
  },
  {
    path: OrganizationPaths.Filters,
    loadComponent: () =>
      import("../_shared/components/table/saved-filter/filter-list/filter-list.component").then(
        (c) => c.FilterListComponent
      ),
    data: {
      breadcrumb: "Filters",
      title: "Filters",
    },
  },
] satisfies Route[];
